// extracted by mini-css-extract-plugin
module.exports = {"editPlayer":"PlayerEdit_editPlayer__jXdEi"};